export default function ServiceIcon({
  width = 15,
  height = 13,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 0H14.75V1.5H8.75V0ZM8.75 5.25H14.75V6.75H8.75V5.25ZM8.75 10.5H14.75V12H8.75V10.5ZM3.875 11.25C3.04657 11.25 2.375 10.5785 2.375 9.75C2.375 8.92155 3.04657 8.25 3.875 8.25C4.70343 8.25 5.375 8.92155 5.375 9.75C5.375 10.5785 4.70343 11.25 3.875 11.25ZM3.875 12.75C5.53186 12.75 6.875 11.4068 6.875 9.75C6.875 8.09317 5.53186 6.75 3.875 6.75C2.21814 6.75 0.875 8.09317 0.875 9.75C0.875 11.4068 2.21814 12.75 3.875 12.75ZM2.75 1.5V3.75H5V1.5H2.75ZM1.25 0H6.5V5.25H1.25V0Z"
        fill={color}
      />
    </svg>
  );
}
